import React, { useState } from "react";
import profile from "../../Assets/Images/undraw_profile.svg";
import { concatenateAndTruncate } from "../../Utils/Application-helper";
import { Tab, Tabs } from "react-bootstrap";

const ProfileView = ({ profileData, followers, following }) => {
  const [key, setKey] = useState("profile");
  const [acKey, setAcKey] = useState("followers");

  const safeFollowers = Array.isArray(followers) ? followers : [];
  const safeFollowing = Array.isArray(following) ? following : [];

  const renderFollowList = (list) => {
    if (!list || list.length === 0) {
      return <p className="text-center mt-4">No Data available</p>;
    }

    return list.map((item) => (
      <div className="row mx-3 mb-3" key={item.id}>
        <div className="col-md-6">
          <div className="d-flex">
            <img
              className="img-profile rounded-circle mr-3"
              src={item.avatar || profile}
              alt="profile"
            />
            <p className="follow-name mb-0 ">
              {item.displayName}
              <br />
              <span className="follow-des">{item.subtitle || "--"}</span>
            </p>
          </div>
        </div>
      </div>
    ));
  };

  const renderProfileData = (data) => {
    if (!data || typeof data !== "object") return null;
    return (
      <ul>
        {Object.entries(data).map(([key, value]) => {
          if (key === "password") return null;
          if (Array.isArray(value)) {
            return (
              <li key={key}>
                <strong>{key}:</strong>
                <ul>
                  {value.map((item, idx) => (
                    <li key={idx}>{typeof item === "object" ? renderProfileData(item) : String(item)}</li>
                  ))}
                </ul>
              </li>
            );
          } else if (typeof value === "object" && value !== null) {
            return (
              <li key={key}>
                <strong>{key}:</strong> {renderProfileData(value)}
              </li>
            );
          } else {
            return (
              <li key={key}>
                <strong>{key}:</strong> {String(value)}
              </li>
            );
          }
        })}
      </ul>
    );
  };

  return (
    <div className="card  card-one-1 mt-3">
      <div className="d-flex align-items-center" style={{ padding: '32px 24px 8px 24px', borderBottom: '1px solid #f0f0f0', marginBottom: 0, marginTop: '40px' }}>
        <div style={{ position: 'relative', marginTop: '8px' }}>
          <img
            className="rounded-circle profile-img ml-1"
            src={profileData?.picUrl || profile}
            alt="profile"
            style={{ width: 90, height: 90, objectFit: 'cover', border: '3px solid #fff', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}
          />
          {profileData?.loginStatus && (
            <span style={{ position: 'absolute', right: 6, bottom: 10, background: '#fff', borderRadius: '50%', padding: 0, border: '2px solid #fff', boxShadow: '0 0 4px rgba(0,0,0,0.08)' }}>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="9" cy="9" r="7" fill="#4FBA3F" stroke="#fff" strokeWidth="2" />
              </svg>
            </span>
          )}
        </div>
        <div className="ml-4" style={{ flex: 1 }}>
          <h4 className="mb-1" style={{ fontWeight: 600 }}>{profileData?.fullName}</h4>
          <div style={{ color: '#888', fontSize: 16, maxWidth: 400, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {concatenateAndTruncate(profileData?.experties || [], 45, "value")}
          </div>
        </div>
      </div>

      <div className="tabbable boxed parentTabs">
        <div className="ad-tab-nav">
          <Tabs
            id="nav-tab"
            className="justify-content-center border-bottom-0 mt-3"
            activeKey={key}
            onSelect={(k) => setKey(k)}
          >
            <Tab
              eventKey="profile"
              title={<p className="tab-pills mb-0">Profile</p>}
            >
              <div className="mx-2 mt-2">
                <div className="card-body py-2">
                  <div className="row">
                    <div className="col-md-12">
                      <h5>User Details</h5>
                      <div style={{ maxHeight: '300px', overflowY: 'auto', border: '1px solid #eee', borderRadius: '6px', padding: '10px', background: '#fafbfc' }}>
                        {renderProfileData(profileData)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mx-2 mt-4" style={{ background: '#fff', borderRadius: '8px', padding: '24px 18px', boxShadow: '0 1px 4px rgba(0,0,0,0.03)', marginBottom: '24px' }}>
                <h5 className="mb-2" style={{ fontWeight: 600 }}>About</h5>
                <p className="mb-4" style={{ color: '#444' }}>{profileData?.about || "No data available"}</p>
                <h5 className="mb-2" style={{ fontWeight: 600 }}>Experience</h5>
                <div className="mb-4" style={{ color: '#444' }}>
                  {profileData?.userExperiances && profileData?.userExperiances.length > 0 ? (
                    <ul style={{ paddingLeft: 18 }}>
                      {profileData.userExperiances.map(({ company_name, position, experiance }, idx) => (
                        <li key={idx} style={{ marginBottom: 6 }}>
                          <span style={{ fontWeight: 500 }}>{company_name}</span>{position ? `, ${position}` : ''}{experiance ? `, ${experiance}` : ''}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <span>No data available</span>
                  )}
                </div>
                <div className="row mb-4">
                  <div className="col-md-6">
                    <h5 className="mb-2" style={{ fontWeight: 600 }}>Skills</h5>
                    {profileData?.skills && profileData?.skills.length > 0 ? (
                      <ul style={{ paddingLeft: 18 }}>
                        {profileData.skills.map((item, idx) => (
                          <li key={idx} style={{ color: '#666', marginBottom: 4 }}>{item?.value}</li>
                        ))}
                      </ul>
                    ) : (
                      <span>No data available</span>
                    )}
                  </div>
                  <div className="col-md-6">
                    <h5 className="mb-2" style={{ fontWeight: 600 }}>Experties</h5>
                    {profileData?.experties && profileData?.experties.length > 0 ? (
                      <ul style={{ paddingLeft: 18 }}>
                        {profileData.experties.map((item, idx) => (
                          <li key={idx} style={{ color: '#666', marginBottom: 4 }}>{item?.value}</li>
                        ))}
                      </ul>
                    ) : (
                      <span>No data available</span>
                    )}
                  </div>
                </div>
                <h5 className="mb-2" style={{ fontWeight: 600 }}>Testimonials</h5>
                <div style={{ color: '#444' }}>
                  There are no testimonials right now
                </div>
              </div>
            </Tab>
            <Tab
              eventKey="activity"
              title={<p className="tab-pills mb-0">Activity</p>}
            >
              <div className="tabbable mt-5 add-tab-nav">
                <Tabs
                  id="nav-tab"
                  activeKey={acKey}
                  className="justify-content-center border-bottom-0 mt-3"
                  onSelect={(k) => setAcKey(k)}
                >
                  <Tab

                    eventKey="followers"

                    title={

                      <p className="text-center  post-txt ">

                        {safeFollowers.length} <br /> Followers{" "}

                      </p>

                    }

                  >

                    {renderFollowList(safeFollowers)}

                  </Tab>

                  <Tab

                    eventKey="following"

                    title={

                      <p className="text-center  post-txt">

                        {safeFollowing.length}

                        <br /> Following{" "}

                      </p>

                    }

                  >

                    {renderFollowList(safeFollowing)}

                  </Tab>



                </Tabs>
                <div className="tab-content">
                  <div className="tab-pane fade mt-4" id="sub22">
                    <div className="row mx-3 mb-3">
                      <div className="col-md-6">
                        <div className="d-flex">
                          <img
                            className="img-profile rounded-circle mr-3"
                            src="img/undraw_profile.svg" alt="profile"
                          />
                          <p className="follow-name mb-0 ">
                            Alexander
                            <br />
                            <span className="follow-des">UI/UX Designer</span>
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="text-center">
                          <button
                            type="button"
                            className="btn btn-secondary unfollow-btn "
                          >
                            Unfollow
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="tab-pane fade mt-4" id="sub23">
                    <div className="row mx-3 mb-3">
                      <div className="col-md-6">
                        <div className="d-flex">
                          <img
                            className="img-profile rounded-circle mr-3"
                            src="img/undraw_profile.svg" alt="profile"
                          />
                          <p className="follow-name mb-0 ">
                            Alexander
                            <br />
                            <span className="follow-des">UI/UX Designer</span>
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="text-center">
                          <button
                            type="button"
                            className="btn btn-secondary unfollow-btn "
                          >
                            Unfollow
                          </button>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </Tab>
            <Tab
              eventKey="sessions"
              title={<p className="tab-pills mb-0">Session Details</p>}
            >
              <div className="mx-2 mt-4">
                <div className="card-body py-2">
                  <h5 className="mb-4">Session Stats</h5>
                  <div style={{ display: 'flex', gap: '32px', flexWrap: 'wrap' }}>
                    <div>
                      <div style={{ fontWeight: 500, color: '#888' }}>Total Sessions</div>
                      <div style={{ fontSize: 28, fontWeight: 600 }}>--</div>
                    </div>
                    <div>
                      <div style={{ fontWeight: 500, color: '#888' }}>Completed</div>
                      <div style={{ fontSize: 28, fontWeight: 600 }}>--</div>
                    </div>
                    <div>
                      <div style={{ fontWeight: 500, color: '#888' }}>Rescheduled</div>
                      <div style={{ fontSize: 28, fontWeight: 600 }}>--</div>
                    </div>
                    <div>
                      <div style={{ fontWeight: 500, color: '#888' }}>Cancelled</div>
                      <div style={{ fontSize: 28, fontWeight: 600 }}>--</div>
                    </div>
                  </div>
                </div>
              </div>
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default ProfileView;



